module.exports = __webpack_public_path__ + "static/media/chestHeightFemale.efc6e67b.png";